import React, { useContext } from "react";
import { observer } from "mobx-react";

import { OfferStoreContext } from "@gp/components";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";

import {
	GroupedPlayerStats,
	GroupedPlayerStatsTable,
} from "@features/offer/desktop";
import { ErrorWrapper } from "@features/offer/shared/statistics";

export default observer(function LivePlayerStatistics() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (store.displayStatisticsGroup === StatisticsGroups.PlayerStats) {
		if (store instanceof AdditionalOfferViewStore) {
			return (
				<ErrorWrapper>
					<GroupedPlayerStats store={store.playerStatisticsStore} />
				</ErrorWrapper>
			);
		}

		return (
			<ErrorWrapper>
				<GroupedPlayerStatsTable store={store.playerStatisticsStore} />
			</ErrorWrapper>
		);
	}
	return null;
});
